import axios from 'axios';
import { BASE_URL } from '../../constants/apiPaths';
import { getAccessToken } from '../../firebase';

const getConfig = (token) => {
    return {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
};
// projectId

// GET /organisation/bounty?organisationId=<id>&page=<page number>&entriesPerPage=<per page entry count></per>
export const getOverallTabData = async (projectId,imageGenerationTimestamp) => {
    try {
        console.log("Overall Tab Data1:",projectId,imageGenerationTimestamp,"dekho aaya h ya nahi timestamp")
        const url = `${BASE_URL}/project/summary?projectId=${projectId}&ranksToFetch=5${imageGenerationTimestamp ?`&intervalEndTimestamp=${imageGenerationTimestamp}` : ""}`;
        // const accessToken = await getAccessToken();
        const response = await axios.get(url);
console.log("Overall Tab Data:",response,"dekho")
        if (response.status === 200 || response.status === 201) {
            console.log("Overall Tab Data:",response,"dekho2")
            return response.data;
        } else {
            return response.data; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
            console.log("Overall Tab Data:",error,"dekho3")
        return error?.response?.data;
    }
};

// {
//     "projectId": projectId,
//     "statistics": [
//         "BOUNTY_WISE_SUBMISSION_COUNT",
//         "BOUNTY_TYPE_WISE_SUBMISSION_COUNT",
//         "BOUNTY_WISE_IMPACT_CERTIFICATE_ISSUED_COUNT",
//         "SDG_WISE_BOUNTY_COUNT",
//         "BOUNTY_WISE_ACCEPTANCE_COORDINATES",
//         "USER_WISE_STATISTICS",
//         "BOUNTY_WISE_REWARDED_AMOUNT"
//     ],
//     "intervalStartTimestamp": "2020-08-21T11:10:15.864+00:00",
//     "intervalEndTimestamp": "2100-08-21T11:10:15.864+00:00"
// }
// projectId

export const getProjectStatistics = async (projectId,statistics,imageGenerationTimestamp,last) => {
    const payload={
        projectId:projectId,
        statistics:[statistics],
        ...(imageGenerationTimestamp && {intervalEndTimestamp: imageGenerationTimestamp})
    }
    try {
        const url = `${BASE_URL}/project/statistics`;
        // const accessToken = await getAccessToken();
        const response = await axios.post(url,payload);
console.log("Overall Tab Data:",response,"dekho graph")
        if (response.status === 200 || response.status === 201) {
            console.log("Overall Tab Data:",response,"dekho2")
            return response.data;
        } else {
            return response.data; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
            console.log("Overall Tab Data:",error,"dekho3 graph")
        return error?.response?.data;
    }
};

// /project/logs?projectId=<project_id></project_id>



export const getProjectLogs = async (projectId,imageGenerationTimestamp) => {
    try {

        const url = `${BASE_URL}/project/logs?projectId=${projectId}${imageGenerationTimestamp ?`&intervalEndTimestamp=${imageGenerationTimestamp}` : ""}`;
        // const accessToken = await getAccessToken();
        const response = await axios.get(url);
console.log("Overall Tab Data:",response,"dekho")
        if (response.status === 200 || response.status === 201) {
            console.log("Overall Tab Data:",response,"dekho2")
            return response.data;
        } else {
            return response.data; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
            console.log("Overall Tab Data:",error,"dekho3")
        return error?.response?.data;
    }
};


export const getActivitiesInProject = async (projectId,imageGenerationTimestamp) => {
    try {
        const url = `${BASE_URL}/project/completedBounties?projectId=${projectId}${imageGenerationTimestamp ?`&intervalEndTimestamp=${imageGenerationTimestamp}` : ""}`;
        // const accessToken = await getAccessToken();
        const response = await axios.get(url);
console.log("Overall Tab Data:",response,"dekho")
        if (response.status === 200 || response.status === 201) {
            console.log("Overall Tab Data:",response,"dekho2")
            return response.data;
        } else {
            return response.data; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
            console.log("Overall Tab Data:",error,"dekho3")
        return error?.response?.data;
    }
};




export const getCertificateDetails = async (certificateId) => {
    try {
        const url = `${BASE_URL}/project/impactCertificate?certificateId=${certificateId}`;
        // const accessToken = await getAccessToken();
        const response = await axios.get(url);
       console.log("Overall Tab Data:",response,"dekho")
        if (response.status === 200 || response.status === 201) {
            console.log("Overall Tab Data:",response,"dekho2")
            return response.data;
        } else {
            return response.data; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
            console.log("Overall Tab Data:",error,"dekho3")
        return error?.response?.data;
    }
};


export const getImpactReportPDF = async (certificateId) => {
    try {
        const url = `${BASE_URL}/project/impactReport?certificateId=${certificateId}`;
        // const accessToken = await getAccessToken();
        const response = await axios.get(url);
       console.log("Impact Report Response:",response,"dekho")
        if (response.status === 200 || response.status === 201) {
            console.log("Impact Report Response:",response,"dekho2")
            return response.data;
        } else {
            return response.data; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
            console.log("Impact Report Response:",error,"dekho3")
        return error?.response?.data;
    }
};


export const getImpactReportPDF2 = async (certificateId) => {
    try {
        const url = `${BASE_URL}/project/impactReport?certificateId=${certificateId}`;
        // const accessToken = await getAccessToken();
        const response = await axios.get(url);
       console.log("Impact Report Response:",response,"dekho")
        if (response.status === 200 || response.status === 201) {
            console.log("Impact Report Response:",response,"dekho2")
            return response.data;
        } else {
            return response.data; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
            console.log("Impact Report Response:",error,"dekho3")
        return error?.response?.data;
    }
};

